module.exports = __webpack_public_path__ + "static/media/pci-logo-short.688b4814.svg";